import React from "react";
import { Icon } from "./Icon";
export const IconChevronDown = (props) => (
  <Icon {...props}>
    <path d="M6 9l6 6 6-6"/>
  </Icon>
);
